import { required } from '@vuelidate/validators'

export const ChangesHistoryValidation = {
    clientId: { required },
    typeId: { required },
}
